/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { orderBy } from "lodash";
import { yearToCropYearFull, OLAPTransformerResult, GLOBAL_UNIT, castUnit } from "../../../shared";
import Highcharts, { SeriesOptionsType } from "highcharts";
import { useChartOptions } from "../../../../charts/useChartOptions";
import { legendPipe, chartPipe, tooltipPipe, addXAxisPipe, addYAxisPipe } from "../../../../charts/pipes";

const CATEGORIES_AXIS = "countries.default";
const SERIES_AXIS = "calendar.default";

export function useChart2(data: OLAPTransformerResult | null, netTradeCountries: number[] | null): Highcharts.Options | undefined {
  const [state, setState] = useState<Highcharts.Options>();

  const categories = useMemo(
    () => {
      const sortedArr = orderBy(data?.columns, x => netTradeCountries?.indexOf(x.selection[CATEGORIES_AXIS] as number));
      return sortedArr?.map((x) => `${x.headers.find((h) => h.id === `${CATEGORIES_AXIS}.name`)?.name}`);
    },
    [data],
  );

  const options = useChartOptions({}, [
    chartPipe("bar"),
    legendPipe("top"),
    addXAxisPipe(categories, {
      min: undefined,
    }),
    addYAxisPipe({
      min: undefined,
      title: {
        text: "million tons",
        align: "low",
        reserveSpace: false,
      },
      labels: {
        formatter: function () {
          var label = this.axis.defaultLabelFormatter.call(this);
          if (/^[0-9]{4}$/.test(label)) {
            return Highcharts.numberFormat(this.value, 0);
          }
          return label;
        },
      },
    }),
    tooltipPipe((serie) => "million tons"),
  ]);

  useEffect(() => {
    if (data) {
      if (data.rows.length) {
        const sortedPoints1 = orderBy(data.rows[0]?.points, p => netTradeCountries?.indexOf(p.column.selection[`${CATEGORIES_AXIS}`] as number));
        const sortedPoints2 = orderBy(data.rows[1]?.points, p => netTradeCountries?.indexOf(p.column.selection[`${CATEGORIES_AXIS}`] as number));
        const sortedRows = [
          { ...data.rows[0], points: sortedPoints1 },
          { ...data.rows[1], points: sortedPoints2 },
        ];
        const columnSeries = sortedRows.map<SeriesOptionsType>((row) => {
          return {
            type: "bar",
            yAxis: 0,
            showInLegend: true,
            dataLabels: {
              enabled: true,
              inside: true,
              formatter: function () {
                return Highcharts.numberFormat(this.y || 0, 1);
              },
            },
            name: yearToCropYearFull(row.attributes?.[`${SERIES_AXIS}.name`]),
            id: row.attributes?.[`${SERIES_AXIS}.name`],
            data: orderBy(row.points, (p) => {
              return categories?.indexOf(p.column?.headers.find((h) => h.id === `${CATEGORIES_AXIS}.name`)?.name ?? "");
            }).map((p) => castUnit(p.value, GLOBAL_UNIT.PRODUCTION_MMT, GLOBAL_UNIT.DISPLAY_PRODUCTION) || 0),
          };
        });

        const result: Highcharts.Options = {
          ...options,
          colors: ["#D9D10C", "#1CA955"],
          series: columnSeries,
        };

        setState(result);
      } else {
        const result: Highcharts.Options = {
          ...options,
          colors: ["#D9D10C", "#1CA955"],
          series: [],
        };

        setState(result);
      }
    }
  }, [data]);
  return state;
}
